package org.example.zone360.utils

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateListOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import kotlinx.browser.document
import kotlinx.browser.localStorage
import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.Json
import org.example.zone360.models.ClubNamesData
import org.example.zone360.models.CustomKeywordsData
import org.example.zone360.models.GetAllTeamsData
import org.example.zone360.models.GetClubCoachesData
import org.example.zone360.models.GetClubSeasonData
import org.example.zone360.models.GetCustomNames
import org.example.zone360.models.GetPlayerData
import org.example.zone360.models.KeywordsUsageData
import org.example.zone360.models.SessionData
import org.example.zone360.models.UserData
import org.w3c.dom.HTMLImageElement

enum class Environment {
    PRODUCTION,
    LOCAL,
    DA
}


val currentEnv: Environment = Environment.PRODUCTION
//val currentEnv: Environment = Environment.LOCAL
enum class SubscriptionPlan {
    MONTHLY, ANNUAL
}


object Constants {
    const val PAGE_WIDTH = 2560
    const val HEADER_HEIGHT = 80
    const val DASHBOARD_HEADER_HEIGHT = 60
    const val FONT_FAMILY = "Inter";
    const val IBM_FONT = "IBM Plex Sans";
    const val EMAIL_REGEX = "^[A-Za-z0-9+_.-]+@[A-Za-z0-9.-]+.[A-Za-z0-9.-]"
    const val SESSION_NAME_NOTE_ALLOWED = "[./_]"
    const val CHUNK_SIZE_BYTES = 5 * 1024 * 1024 // 5MB
    const val DEFAULT_DELAY_MS = 100L // Used for progress tracking delay
    const val AUDIO_SYNC_DELAY_MS = 50L // Slightly faster delay for audio-video sync

    ///
    const val COLOR_MODE_KEY = "COLOR_MODE_KEY"
    var lastSyncTime = 0.0
    var PASSWORD_LENGTH = 8

    ///
    const val USER_KEY = "USER_KEY"
    val base_Media_URL =
        if (currentEnv == Environment.PRODUCTION) "https://zone360productionstorage.blob.core.windows.net/" else "https://zone360storage.blob.core.windows.net/"
    const val VERSION = "Version 1.0.68"
}

object Res {

    object Price {
        val testPriceIDLive = "price_1Rsz4KGYbUQVSVNpQqGvle1m"
        val clubPriceId =
            if (currentEnv == Environment.PRODUCTION) "price_1RtVFxGYbUQVSVNpFAY0V9C7" else "price_1SshmFGf3wuEvfxS19wQvVKH"
        val coachPriceId =
            if (currentEnv == Environment.PRODUCTION) "price_1RtVEmGYbUQVSVNplMs9qvnT" else "price_1Su9BgGf3wuEvfxSORsWmiB2"
        val playerPriceId =
            if (currentEnv == Environment.PRODUCTION) "price_1RtVCfGYbUQVSVNp5WI1ooly" else "price_1RoGgJGYbUQVSVNpYlA6UAaN"
    }

    // Images
    object Images {
        const val logosvg = "logo.svg"
        const val paidsvg = "paid_icon.svg"
        const val logopng = "logo.png"
        const val faviconico = "favicon.ico"
        const val whistle = "whistle.svg"
        const val footballicon = "football.svg"
        const val share_Nodes = "share_nodes.svg"
        const val clockIcon = "clock.svg"
        const val matteo = "matteo.svg"
        const val alex = "alex.svg"
        const val brianPic = "briananderson.svg"
        const val michealPic = "michealbrown.svg"
        const val johnPic = "johnsmith.svg"
        const val kevinPic = "kevin.svg"
        const val playbutton = "playbutton.svg"
        const val pausebutton = "pausebutton.svg"
        const val groupGraph = "graphgroup.svg"
        const val tactical = "tactical.svg"
        const val technical = "technical.svg"
        const val fitness = "fitness.svg"
        const val mental = "mental.svg"
        const val goalkeeper = "goalkeeper.svg"
        const val blueCircle = "bluecircle.svg"
        const val club_Performance_Chart = "club_performance_chart.svg"
        const val updated_graph_var = " updated_graph_var.png"
        const val line = "line.svg"
        const val technicalChart = "technicalChart.svg"
        const val tacticalChart = "tactical_Chart.svg"
        const val mentalChart = "mentalChart.svg"
        const val fitnessChart = "fitnessChart.svg"
        const val goalkeeperChart = "goalkeeperChart.svg"
        const val customChart = "customChart.svg"
        const val footballPrimary = "football_primary.png"
        const val football512px = "football512px.png"
        const val userIcon = "userIcon.png"
        const val userIconSquare = "userIconSquare.svg"
        const val timeCircle = "Time_circle.svg"
        const val calender = "Calendar.svg"
        const val calender_white = "calendar_white.svg"
        val base_Image_Url = "${Constants.base_Media_URL}images/"
        const val cornerResize = "cornerResize.png"
        const val coachPic = "coachPic.svg"
        const val keywordIcon = "keywordIcon.svg"
        const val nationalityFlag = "nationality.svg"
        const val nationalityFlag_white = "nationalityFlag_white.svg"
        const val teamIcon = "teamIcon.svg"
        const val shirt_number_white = "shirt_number_white.svg"
        const val teamIcon_white = "teamIcon_white.svg"
        const val downloadPrimary = "downloadPrimary.svg"
        const val checkmark = "check_solid.svg"
        const val recording_Voice = "record_voice_over.svg"
        const val total_duration = "total_duration.svg"
        const val total_keywords = "total_keywords.svg"
        const val total_words = "total_words.svg"
        const val percentageChart = "percentagechart-graphic.svg"
        const val spiderChart = "spider_chart.svg"
        const val toneChart = "tone_chart.svg"
        const val recordingPlay = "recording_playing.svg"
        const val sentimental_Ratio = "sentimentalRatio.svg"
        const val play_all_button = "play_all_button.svg"
        const val excitedEmoji = "excitedEmoji.svg"
        const val positiveEmoji = "positiveEmoji.svg"
        const val groundSvg = "ground.svg"
        const val heightMeasure = "heightMeasurement.svg"
        const val heightMeasure_white = "heightMeasurement_white.svg"
        const val weightMeasurement = "weightMeasurement.svg"
        const val website_logo_zone360_trans = "website_logo_zone360.svg"
        const val weightMeasurement_white = "white_weight_measure.svg"
        const val arrow_Left = "arrow-left.svg"
        const val arrow_Right = "arrow_right.svg"
        const val cross_Icon = "crossIcon.svg"
        const val vector_Next = "vector_Next.svg"
        const val assistAiBibi = "AssistAi.svg"
        const val assistAi = "AssistAiBaba.svg"
        const val assistAiMatt = "matteo.jpeg"
        const val chatBot = "chat-bubble.png"
        const val connect_Device = "connect_device.svg"
        const val am_Attacking = "am_attacking.svg"
        const val dm_svg = "dm.svg"
        const val gk_svg = "gk_goalkeeper.svg"
        const val grondFrame = "grondFrame.svg"
        const val lcd_svg = "lcd.svg"
        const val lld_svg = "lld.svg"
        const val lw_svg = "lw.svg"
        const val rcd_svg = "rcd.svg"
        const val rld_svg = "rld.svg"
        const val rw_svg = "rw.svg"
        const val st_svg = "st.svg"
        const val send_Button = "sendButton.svg"
        const val cross_Red = "remove.png"
        const val field_boundary = "field_boundary.svg"
        const val coach_profile_bd = "coach_profile_bd.svg"
        const val player_profile_bd_wo_logo = "player_profile_bd_wo_logo.svg"
        const val player_profile_bd = "player_profile_bg.svg"
        const val png_pattern1 = "patteren1.png"
        const val svg_pattern = "patteren2.svg"
        const val portfolio_report = "portfolio_reports.svg"
        const val invite_coach = "Invite.svg"
        const val share_nodes_white = "share_nodes_white.svg"
        const val gray_Pencil_Icon = "pencilIconGray.svg"
        const val white_Pencil_Icon = "pencilIcon_white.svg"
        const val foot_icon_white = "foot.png"
        const val player_Bg_Vector = "export_new_bg.svg"
        const val custom_Highlight_Icon = "custom_highlight.svg"
        const val tag_Icon = "tag.png"
        const val football_LowScale = "football_low_scale.png"
        const val download_Cloud_Arrow = "download_cloud_arrow.png"
        const val upload_Cloud_Arrow = "upload_cloud_arrow.png"
        const val camera_icon = "camer_icon.svg"
        const val refresh_icon = "refresh.png"
        const val sync_icon = "refreshs.png"
        const val loading_gif = "loading-2.gif"
        const val running_shoes = "running-shoes.png"
        const val document_black = "clipboard.png"
        const val leaf = "leaf.png"
        const val shield = "shield icon.png"
        const val trophy = "trophy.png"
        const val rising = "rising.png"
        const val right_left = "right_left.png"
        const val green_soccer = "green_soccer.png"
        const val shield_blue = "shield.png"
        const val action = "flash.png"
        const val expand_screen = "expand_screen.png"
        const val expand_arrow = "expand-arrows.png"
        const val minimize_screen = "minimize_screen.png"
        const val full_screen = "chevron.png"
        const val expandable = "expandable.png"
        const val down_arrow = "down-arrow-square-outlined-button.png"

    }

    object Id {

        // Input IDs
        const val usernameInput = "usernameInput"
        const val searchInput = "searchInput"
        const val createClubSeason = "create-Club-Season"
        const val searchSeason = "searchSeason"
        const val emailInput = "emailInput"
        const val passwordInput = "passwordInput"
        const val seasonDropdown = "seasonDropdown"
        const val currentPasswordInput = "currentPasswordInput"
        const val newPasswordInput = "newPasswordInput"
        const val confirmPasswordInput = "confirmPasswordInput"
        const val changePasswordToast = "changePasswordToast"
        const val userSearchInput = "userSearchInput"
        const val coachName = "coachName"
        const val teamName = "teamName"
        const val seasonName = "seasonName"
        const val startDate = "startDate"
        const val endDate = "endDate"
        const val clubName = "clubName"
        const val firstName = "firstNameInput"
        const val lastName = "lastNameInput"
        const val count = "lastNameInput"
        const val clubID = "clubID"
        const val orginization = "organizationInput"
        const val fileInput = "fileInput"
        const val dashboradPage = "dashboardPage"
        const val coachesPage = "coachesPage"
        const val playersPage = "playersPage"
        const val nationality = "nationality"
        const val coachId = "coachId"
        const val messageAiInput = "messageAiInput"
        const val scrollContainerId = "chatScrollContainer"
        const val coachInfoHeader = "coachInfoHeader"
        const val playerInfoHeader = "coachInfoHeader"
        const val spiderChart = "spiderChart"
        const val coachImage = "coachImage"
        const val clubImage = "clubImage"
        const val playerImage = "playerImage"
        const val startMinute = "startMinute"
        const val startSeconds = "startSeconds"
        const val endMinute = "endMinute"
        const val messageColumSection = "messageColumSection"
        const val endSeconds = "endSeconds"
        const val radarChart = "radarChart"
        const val radarChartSnapShot = "radarChartSnapshot"
        const val infoDonutChart = "infoDonutChart"
        const val infoDonutChartSnapShot = "infoDonutChartSnapshot"
        const val customHighlights = "customHighlights"
        const val transcript = "transcript"
        const val coachTalkGauge = "coachTalkGauge"
        const val sessionIntensityGauge = "sessionIntensityGauge"
        const val gameRealismGauge = "gameRealismGauge"
        const val developmentOrientationGauge = "developmentOrientationGauge"
        const val tacticalComplexityGauge = "tacticalComplexityGauge"
        const val topicDiversityGauge = "topicDiversityGauge"
        const val methodologyConsistencyGauge = "methodologyConsistencyGauge"
        const val cognitiveTrainingGauge = "cognitiveTrainingGauge"
        const val competitiveEnvironmentGauge = "competitiveEnvironmentGauge"
        const val defensiveOrgGauge = "defensiveOrgGauge"
        const val setPieceGauge = "setPieceGauge"
        const val note = "note"
        const val tagCoach = "tagCoach"
        const val editSummary = "edit-summary"
        const val updateTranscript = "update-transcript"
        const val updateNotes = "update-notes"
        const val updateJob = "update_job"
        const val updateNationality = "update_nationality"
        const val updateEthnicity = "update_Ethnicity"
        const val updateAge = "update_Age"
        const val updateHeight = "update_Height"
        const val updateWeight = "update_Weight"
        const val updateNumber= "update_nationality"
        const val cardNumber= "cardNumber"
        const val cardName= "cardName"
        const val cardDate= "cardDate"
        const val quickActionsContainer= "quickActionsContainer"
        const val cvv= "cvv"
        const val sessionName= "sessionName"
        const val sessionType= "sessionType"
        const val clubPriceId = "price_1RoGdmGYbUQVSVNp6clLebhA"
        const val coachPriceId = "price_1RoGbLGYbUQVSVNp6mwDn85o"
        const val playerPriceId = "price_1RoGgJGYbUQVSVNpYlA6UAaN"
        const val importCsv = "importCsv"
        const val updateNickname = "updateNickname"
        const val coachDashboardBot = "coachDashboardBot"
        const val coachOverlay = "coachOverlay"
        const val dashboardScrollContainer = "dashboardScrollContainer"
        const val popupScrollContainerDashboard = "popupScrollContainerDashboard"
        const val playerChatBot = "playerChatBot"
        const val playerPopupChatBot = "playerPopupChatBot"
        const val dashboardMessageInput = "dashboardMessageInput"
        const val popupMessageInput = "popupMessageInput"
        const val coachMessageInput = "coachMessageInput"
        const val coachPopupInputField = "coachPopupInputField"
        const val playerMessageInputField = "playerMessageInputField"
        const val playerPopupMessage = "playerPopupMessage"


    }

    object Audio {
        val audio_base_url = "${Constants.base_Media_URL}audios/"
    }

    object Video {
        val base_Video_URL = "${Constants.base_Media_URL}videos/"
        const val traing_Video_YT = "training_video.mp4"
        const val video_For_Demo =
            "https://zone-360-images.s3.us-south.cloud-object-storage.appdomain.cloud/Juventus%202014%20DNA%20Prep%20Recording%20-%20Tactical%20(1).mp4"
    }
    object Files{
        const val PLAYERS_CSV = "/sample_players_list.csv"
        const val COACHES_CSV = "/sample_coaches_list.csv"
    }
}

object Route {
    const val SING_UP = "/playersignup"
}

object Strings {
    const val INDEPENDENT = "independent"
    const val PLAYER = "player"
    const val COACH = "coach"
    const val ADMIN = "admin"
    const val PAID = "paid"
    const val ACTIVE = "active"
    const val SUCCEEDED = "succeeded"
    const val POST = "POST"
    const val TAGGED = "tagged"
    const val COMPLETED = "completed"
    const val TRAINING = "training"
    const val MATCH = "match"
    const val YYYY_MM_DD = "YYYY-MM-DD"

    const val DEFAULT_SEASON = "Season 2025-2026"
    val CATEGORY_LIST = listOf(
        "Tactical",
        "Fitness",
        "Mental",
        "Technical",
        "Goalkeeper"
    )
    val REQUEST_OPTIONS = listOf(
        "Request Assessment",
        "Request Training",
        "Request Match"
    )
    val SELECT_SESSION = listOf(
        "Training",
        "Match"
    )
    val WEEK_DAYS_LIST = listOf(
        "Sun" , "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"
    )

    val KEYWORD_LIST = listOf(
        "All Keywords",
        "Club Keywords",
    )
    val LANGUAGES_LIST = listOf(
        "All Languages",
        "English",
        "Italian",
        "Spanish",
        "French",
    )
    val LANGUAGES_LIST_ADD = listOf(
        "Select Language",
        "English",
        "Italian",
        "Spanish",
        "French",
    )
    val CATEGORY_LIST_FOR_KEYWORDS = listOf(
        "All Categories",
        "Tactical",
        "Fitness",
        "Mental",
        "Technical",
        "Goalkeeper",
        "Custom"
    )
    val CATEGORY_LIST_FOR_NAMES = listOf(
        "All Categories",
        "Person"
    )
}

object ToastID {
    const val ERROR = "toastError"
    const val SUCCESS = "toastSuccess"
}

enum class SelectedLanguage {
    English, Italian
}

enum class SelectedData {
    Training, Matches
}


enum class SelectedKeywords {
    Detected, FullList
}

enum class UploadedType {
    SharedByPlayer, SharedByCoach
}

enum class CoachesOrPlayer {
    Coaches, Players
}

enum class RecentHighlights {
    RecentAssessment, RecentSession
}


object ImagePreloader {
    private val preloadedImages = mutableMapOf<String, Boolean>()

    fun preloadImage(url: String) {
        if (!preloadedImages.containsKey(url)) {
            val img = document.createElement("img") as HTMLImageElement
            img.src = url
            preloadedImages[url] = true
        }
    }

    fun preloadImages(urls: List<String>) {
        urls.take(15).forEach { preloadImage(it) }
    }

    fun isPreloaded(url: String) = preloadedImages.containsKey(url)
}

class AppGlobal {
    companion object {
        var userData: UserData
            get() {
                val data = localStorage.getItem("userData")
                val user = if (data != null) Json.decodeFromString<UserData>(data) else UserData()
                imageUrl = user.imageUrl
                return user
            }
            set(value) {
                localStorage.setItem("userData", Json.encodeToString(value))
                imageUrl = value.imageUrl
                imageVersion++
            }

        var imageUrl by mutableStateOf("")
        var imageVersion by mutableStateOf(0L)

        val clubCoachesList = mutableStateListOf<GetClubCoachesData>()
        val clubSessionList = mutableStateListOf<SessionData>()
        val keywordResponse = mutableStateListOf<KeywordsUsageData>()
        val clubPlayersList = mutableStateListOf<GetPlayerData>()
        val teamDataList = mutableStateListOf<GetAllTeamsData>()
        val seasonDataList = mutableStateListOf<GetClubSeasonData>()
        val clubKeywordsList = mutableStateListOf<CustomKeywordsData>()
        var updateNotifications by mutableStateOf("")
        var refreshSessions by mutableStateOf("")
        var refreshPlayerList by mutableStateOf("")
        var refreshPlayerProfile by mutableStateOf("")
        var refreshCoachProfile by mutableStateOf("")
        var refreshGetProfileInPlayer by mutableStateOf("")
        var selectedSeason by mutableStateOf("")
        var selectedSeasonId by mutableStateOf("")
        var seasonUpdate by mutableStateOf(0L)
        var customNamesList = mutableStateListOf<GetCustomNames>()
        var clubNameDataList = mutableStateListOf<ClubNamesData>()
        var dashboardLoaded by mutableStateOf(false)
        var imagePreloadTrigger by mutableStateOf(0L)
        var isDashboardChatbotExpanded by mutableStateOf(false)
        var isCoachChatbotExpanded by mutableStateOf(false)
        var isPlayerChatbotExpanded by mutableStateOf(false)

    }
}

